// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdownWithInput {
  position: relative;
  margin-top: 23px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
}
.dropdownWithInput .inputWrapper {
  position: relative;
  height: 50px;
  font-weight: 400;
  padding-left: 16px;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  border-radius: 8px;
  width: 100%;
  display: flex;
  flex-direction: row;
}
.dropdownWithInput .inputWrapper .selectWrapper {
  position: relative;
  display: inline-block;
  width: 134px;
  border-right: 1px solid #e9e9e9;
  height: 48px;
}
.dropdownWithInput .inputWrapper .selectWrapper .selectField {
  border: none;
  opacity: 100 !important;
  height: 20px;
  font-size: 16px;
  font-family: "Inter";
  color: #353d47;
  background-color: white;
  position: relative;
  top: 14px;
  width: 95%;
}
.dropdownWithInput .inputWrapper .textInputWrapper {
  display: flex;
  position: relative;
  align-content: space-between;
  width: 100%;
}
.dropdownWithInput .inputWrapper .textInputWrapper .textInput {
  position: relative;
  top: 15px;
  width: calc(100% - 41px);
  height: 20px;
  z-index: 200;
  opacity: 100% !important;
  margin-left: auto;
  border: none;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #c1c1c1;
  position: relative;
  margin-left: 16px;
}
.dropdownWithInput .inputWrapper .textInputWrapper .textInput:focus-visible {
  outline: none !important;
}
.dropdownWithInput .inputWrapper .textInputWrapper .textLabel {
  margin-left: auto;
  text-align: right;
  display: inline-block;
  padding-top: 13px;
  position: relative;
  width: 25px;
  margin-right: 16px;
}
.dropdownWithInput .InputLabel {
  position: relative;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #353d47;
  padding-bottom: 4px;
  display: flex;
  align-content: space-between;
}`, "",{"version":3,"sources":["webpack://./src/components/dropdownWithInput/dropdownWithInput.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;AACJ;AAAI;EACI,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;AAER;AADQ;EACI,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,+BAAA;EACA,YAAA;AAGZ;AAFY;EACI,YAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;EACA,uBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AAIhB;AADQ;EACI,aAAA;EACA,kBAAA;EACA,4BAAA;EACA,WAAA;AAGZ;AAFY;EACI,kBAAA;EACA,SAAA;EACA,wBAAA;EACA,YAAA;EACA,YAAA;EACA,wBAAA;EACA,iBAAA;EACA,YAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;AAIhB;AAFY;EACI,wBAAA;AAIhB;AAFY;EACI,iBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;AAIhB;AAAI;EACI,kBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;EACA,4BAAA;AAER","sourcesContent":[".dropdownWithInput {\n    position: relative;\n    margin-top: 23px;\n    margin-bottom: 20px;\n    display: flex;\n    flex-direction: column;\n    .inputWrapper {\n        position: relative;\n        height: 50px;\n        font-weight: 400;\n        padding-left: 16px;\n        background: #ffffff;\n        border: 1px solid #e9e9e9;\n        border-radius: 8px;\n        width: 100%;\n        display: flex;\n        flex-direction: row;\n        .selectWrapper {\n            position: relative;\n            display: inline-block;\n            width: 134px;\n            border-right: 1px solid #e9e9e9;\n            height: 48px;\n            .selectField {\n                border: none;\n                opacity: 100 !important;\n                height: 20px;\n                font-size: 16px;\n                font-family: 'Inter';\n                color: #353d47;\n                background-color: white;\n                position: relative;\n                top: 14px;\n                width: 95%;\n            }\n        }\n        .textInputWrapper {\n            display: flex;\n            position: relative;\n            align-content: space-between;\n            width: 100%;\n            .textInput {\n                position: relative;\n                top: 15px;\n                width: calc(100% - 41px);\n                height: 20px;\n                z-index: 200;\n                opacity: 100% !important;\n                margin-left: auto;\n                border: none;\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 400;\n                font-size: 16px;\n                line-height: 24px;\n                color: #c1c1c1;\n                position: relative;\n                margin-left: 16px;\n            }\n            .textInput:focus-visible {\n                outline: none !important;\n            }\n            .textLabel {\n                margin-left: auto;\n                text-align: right;\n                display: inline-block;\n                padding-top: 13px;\n                position: relative;\n                width: 25px;\n                margin-right: 16px;\n            }\n        }\n    }\n    .InputLabel {\n        position: relative;\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 14px;\n        line-height: 20px;\n        color: #353d47;\n        padding-bottom: 4px;\n        display: flex;\n        align-content: space-between;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
